import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import styled, { css } from 'styled-components';

import { NavigationItemButtonProps } from '@/shared/features/sidebar/components/navigation-item/navigation-item.types';

const navigationItemHover = css<NavigationItemButtonProps>`
  background-color: ${({ theme, $active }) =>
    !$active && theme.palette.primary.light}4D !important; // 4D = 30% opacity
`;

export const NavigationItemButton = styled(
  ListItemButton,
)<NavigationItemButtonProps>`
  && {
    gap: 0.5rem;
    min-height: 2.75rem;
    height: 2.75rem;
    min-width: 2.75rem;
    border-radius: ${({ theme }) => theme.shape.buttonRadius.large};
    padding: 0.75rem;
    position: relative;
    color: ${({ theme }) => theme.palette.text.primary};
    transition: 0.2s ease-in-out;

    ${({ theme }) => theme.typography.button1};

    &:hover {
      ${navigationItemHover}
    }

    ${({ $clicked }) => $clicked && navigationItemHover}

    & .MuiListItemIcon-root svg {
      color: ${({ theme, $active }) =>
        $active
          ? theme.palette.primary.contrastText
          : theme.palette.primary.main};
    }

    ${({ $active, theme }) =>
      $active &&
      css`
        background-color: ${theme.palette.primary.main} !important;
        color: ${theme.palette.primary.contrastText};

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: -1.25rem;
          width: 5px;
          border-radius: ${({ theme }) =>
            `0 ${theme.shape.buttonRadius.large} ${theme.shape.buttonRadius.large} 0`};
          height: 100%;
          background-color: ${theme.palette.primary.main};
        }
      `}
  }
`;

export const NavigationItemIcon = styled(ListItemIcon)`
  && {
    min-width: 0;
    justify-content: center;

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
`;

type NavigationItemNameProps = {
  $open?: boolean;
};

export const NavigationItemName = styled(ListItemText)<NavigationItemNameProps>`
  && {
    opacity: ${({ $open }) => ($open ? 1 : 0)};
    transition: opacity 0.3s;

    & > span {
      ${({ theme }) => theme.typography.button2};
    }
  }
`;
